<script setup>
const { id } = defineProps(['id'])

const { data } = useAsyncData('my-data', () => {
  return $fetch('/api/sidebar-nav', {
    headers: {
      'Accept-Language': 'en-US',
      'Accept': 'application/json',
    },
    query: {
      id,
    },
  })
})
</script>

<template>
  <nav
    v-if="data != null"
    class="subnav"
    aria-label="Section navigation"
  >
    <UCollapsible class="flex flex-col w-full card-shadow rounded-xl xl:hidden">
      <UButton
        class="group data-[state=open]:rounded-none border-0  data-[state=open]:bg-med-light-aqua  data-[state=open]:text-primary"
        style="border-top-left-radius: 10px; border-top-right-radius: 10px;"
        :label="data?.currentPageLabel"
        color="neutral"
        variant="solid"
        trailing-icon="i-lucide-chevron-down"
        :ui="{
          trailingIcon: 'group-data-[state=open]:rotate-180 transition-transform duration-200',
        }"
        block
      />

      <template #content>
        <div class="subnav__body">
          <ul class="subnav__list">
            <li
              class="subnav__item"
              :class="{ active: data.active }"
            >
              <ULink
                v-if="data.sectionLinkUrl"
                :to="useCmsUrl(data.sectionLinkUrl)"
                :locale="false"
                class="text-primary"
              >
                {{ data.sectionHeading }}
              </ULink>
              <span
                v-else
                class="text-primary"
              >
                {{ data.sectionHeading }}
              </span>
              <ul class="subnav__list">
                <li
                  v-for="child in data.children"
                  :key="child.text"

                  class="subnav__item"
                  :class="{ active: child.active }"
                >
                  <ULink
                    :to="useCmsUrl(child.link)"
                    :locale="false"
                    class="text-primary"
                  >
                    {{ child.text }}
                  </ULink>
                  <ul
                    v-if="child.children != null"
                    class="subnav__list"
                  >
                    <li
                      v-for="grandchild in child.children"
                      :key="grandchild.text"

                      class="subnav__item"
                      :class="{ active: grandchild.active }"
                    >
                      <ULink
                        :to="useCmsUrl(grandchild.link)"
                        :locale="false"
                        class="text-med-navy"
                      >
                        {{ grandchild.text }}
                      </ULink>
                      <ul
                        v-if="grandchild.children != null"
                        class="subnav__list"
                      >
                        <li
                          v-for="greatgrandchild in grandchild.children"
                          :key="greatgrandchild.text"
                          class="subnav__item"
                          :class="{ active: greatgrandchild.active }"
                        >
                          <ULink
                            :to="useCmsUrl(greatgrandchild.link)"
                            :locale="false"
                            class="text-primary"
                          >
                            {{ greatgrandchild.text }}
                          </ULink>
                          <ul
                            v-if="greatgrandchild.children != null"
                            class="subnav__list"
                          >
                            <li
                              v-for="greatgreatgrandchild in greatgrandchild.children"
                              :key="greatgreatgrandchild.text"

                              class="subnav__item"
                              :class="{ active: greatgreatgrandchild.active }"
                            >
                              <ULink
                                :href="useCmsUrl(greatgreatgrandchild.link)"
                                :locale="false"
                                class="text-primary"
                              >
                                {{ greatgreatgrandchild.text }}
                              </ULink>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </template>
    </UCollapsible>

    <!-- desktop subnav -->
    <div class="subnav__body hidden xl:block">
      <div class="h2 subnav__title">
        <ULink
          v-if="data.sectionLinkUrl"
          :to="useCmsUrl(data.sectionLinkUrl)"
          :locale="false"
          class="text-primary"
        >
          {{ data.sectionHeading }}
        </ULink>
        <span
          v-else
          class="text-primary"
        >
          {{ data.sectionHeading }}
        </span>
      </div>

      <ul class="subnav__list">
        <li
          v-for="child in data.children"
          :key="child.text"

          class="subnav__item"
          :class="{ active: child.active }"
        >
          <ULink
            :to="useCmsUrl(child.link)"
            :locale="false"
            class="text-primary"
          >
            {{ child.text }}
          </ULink>
          <ul
            v-if="child.children != null"
            class="subnav__list"
          >
            <li
              v-for="grandchild in child.children"
              :key="grandchild.text"

              class="subnav__item"
              :class="{ active: grandchild.active }"
            >
              <ULink
                :to="useCmsUrl(grandchild.link)"
                :locale="false"
                class="text-med-navy"
              >
                {{ grandchild.text }}
              </ULink>
              <ul
                v-if="grandchild.children != null"
                class="subnav__list"
              >
                <li
                  v-for="greatgrandchild in grandchild.children"
                  :key="greatgrandchild.text"
                  class="subnav__item"
                  :class="{ active: greatgrandchild.active }"
                >
                  <ULink
                    :to="useCmsUrl(greatgrandchild.link)"
                    :locale="false"
                    class="text-primary"
                  >
                    {{ greatgrandchild.text }}
                  </ULink>
                  <ul
                    v-if="greatgrandchild.children != null"
                    class="subnav__list"
                  >
                    <li
                      v-for="greatgreatgrandchild in greatgrandchild.children"
                      :key="greatgreatgrandchild.text"

                      class="subnav__item"
                      :class="{ active: greatgreatgrandchild.active }"
                    >
                      <ULink
                        class="text-med-navy"
                        :to="useCmsUrl(greatgreatgrandchild.link)"
                        :locale="false"
                      >
                        {{ greatgreatgrandchild.text }}
                      </ULink>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </nav>
</template>
